import "./EmptyState.css";

const EmptyState = ({
  icon,
  title = "Nothing here yet",
  message = "No records found.",
  buttonIcon = "plus-circle",
  buttonText,
  onButtonClick,
  children
}) => {
  return (
    <div className="empty-state">

      <div className="empty-state-icon">
        {icon && (
          <img src="/images/empty.gif" alt="" />
        )}
      </div>

      <h3>{title}</h3>

      <p>{message}</p>

      {buttonText && (
        <button
          className="btn-primary btn"
          onClick={onButtonClick}
        >
          <i className={`bi bi-${buttonIcon}`}></i>{" "}
          {buttonText}
        </button>
      )}

      {children}

    </div>
  );
};

export default EmptyState;